import { render, staticRenderFns } from "./interface.vue?vue&type=template&id=25e37f4b&scoped=true"
import script from "./interface.vue?vue&type=script&lang=js"
export * from "./interface.vue?vue&type=script&lang=js"
import style0 from "./interface.vue?vue&type=style&index=0&id=25e37f4b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e37f4b",
  null
  
)

export default component.exports